import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const SectionTransition = ({ testId }) => (
  <div
    data-testid={testId}
    aria-hidden="true"
    className="absolute inset-x-0 top-0 z-10 mx-auto flex w-full max-w-7xl items-center px-6 lg:px-10"
  >
    <span className="h-px flex-1 bg-[#222736]" />
    <motion.span
      initial={{ scaleX: 0, opacity: 0 }}
      whileInView={{ scaleX: 1, opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 1, ease: EASE }}
      className="h-px w-16 origin-center bg-[#FF5500] shadow-[0_0_14px_rgba(255,85,0,0.4)] sm:w-24"
    />
    <span className="h-px flex-1 bg-[#222736]" />
  </div>
);